"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));
require("react-day-picker/lib/style.css");
var _Button = require("./Button");
var _styles = require("@material-ui/core/styles");
var _clsx7 = _interopRequireDefault(require("clsx"));
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Typography = require("./Typography");
var _DatePicker = require("../modules/DatePicker");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    //@ts-ignore
    container: _objectSpread(_objectSpread({
      height: "100%",
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      backgroundColor: function backgroundColor(props) {
        return props.darkMode ? _pittaModules.DarkColors.primary["0"] : _pittaModules.LightColors.primary["0"];
      },
      color: function color(props) {
        return props.darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"];
      },
      fontFamily: "Roboto"
    }, _Fonts.Fonts.Default.Caption), {}, {
      borderRadius: 12
    }),
    //@ts-ignore
    selector: _objectSpread({
      width: 560,
      height: 40,
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end"
    }, _Fonts.Fonts.Default.Button),
    selector__labels: {
      display: "flex",
      marginTop: 16
    },
    selector__range: {
      width: 46,
      height: 24,
      lineHeight: "24px",
      color: function color(props) {
        return props.variant === "range" ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.primary["2"];
      }
    },
    selector__dot: {
      width: 5,
      height: 24,
      lineHeight: "24px",
      margin: "0 4px 0 3px",
      color: _pittaModules.LightColors.primary["2"]
    },
    selector__multiple: {
      width: 59,
      height: 24,
      lineHeight: "24px",
      color: function color(props) {
        return props.variant === "multi" ? _pittaModules.LightColors.primary["7"] : _pittaModules.LightColors.primary["2"];
      }
    },
    //@ts-ignore
    count: _objectSpread(_objectSpread({
      display: "flex",
      width: 43,
      height: 24,
      color: _pittaModules.LightColors.primary["2"]
    }, _Fonts.Fonts.Default.Caption), {}, {
      fontFamily: "Roboto",
      fontSize: 16
    }),
    countError: {
      color: _pittaModules.LightColors.secondary["11"]
    },
    datePickerDiv: {
      flex: 1,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "&::-webkit-scrollbar": {
        width: 6
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "".concat(_pittaModules.LightColors.primary["1"], "5A"),
        borderRadius: 3
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent"
      },
      padding: theme.spacing(2, 0)
    },
    dateTypeDiv: {
      width: "100%",
      height: 48,
      display: "flex",
      // flex: "1 0 auto",
      justifyContent: "center",
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["5"]),
      position: "relative"
    },
    dateTypeTextDiv: {
      flex: 1,
      height: 49,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    dateTypeText: {
      color: _pittaModules.LightColors.primary["2"],
      cursor: "pointer",
      "&:hover": {
        color: _pittaModules.LightColors.primary["8"]
      },
      padding: theme.spacing(0, 1)
    },
    dateTypeTextActive: {
      color: _pittaModules.LightColors.primary["7"]
    },
    dateActiveDiv: _objectSpread(_objectSpread({
      position: "absolute",
      bottom: -1
    }, theme.direction === "rtl" ? {
      right: 0,
      transition: theme.transitions.create("right")
    } : {
      left: 0,
      transition: theme.transitions.create("left")
    }), {}, {
      borderBottom: "3px solid ".concat(_pittaModules.LightColors.primary["7"]),
      width: "50%"
    }),
    activeMulti: _objectSpread({}, theme.direction === "rtl" ? {
      right: "50%"
    } : {
      left: "50%"
    }),
    btnDiv: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: function height(props) {
        return props.mobile ? 68 : 76;
      },
      padding: theme.spacing(0, 2)
    },
    btnMargin: _objectSpread({}, theme.direction === "rtl" ? {
      marginLeft: theme.spacing(2)
    } : {
      marginRight: theme.spacing(2)
    }),
    btnDivMobile: {
      borderTop: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    },
    loadginDiv: {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      background: "".concat(_pittaModules.LightColors.primary["1"], "5A")
    },
    weekTextDiv: {
      display: "flex",
      justifyContent: "center"
    },
    weekTextRowDiv: {
      display: "flex",
      // justifyContent: "space-between",
      paddingBottom: 6,
      width: 288,
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    },
    weekText: {
      color: function color(props) {
        return props.darkMode ? "#FFFFFF" : "#68686E";
      },
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: 14,
      lineHeight: 1.333,
      width: "14.29%",
      height: 21,
      padding: 0
    },
    noHover: {
      "&:hover": {
        color: function color(props) {
          return props.darkMode ? _pittaModules.DarkColors.primary["1"] + " !important" : _pittaModules.LightColors.primary["1"] + " !important";
        }
      },
      "&:active": {
        color: function color(props) {
          return props.darkMode ? _pittaModules.DarkColors.primary["1"] + " !important" : _pittaModules.LightColors.primary["1"] + " !important";
        }
      }
    }
  });
});
var DatePicker = function DatePicker(props) {
  var _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9;
  var classes = useStyles(props);
  var variant = props.variant,
    total = props.total,
    enabledDays = props.enabledDays,
    mobile = props.mobile,
    onClickOK = props.onClickOK,
    onChangeVariant = props.onChangeVariant,
    t = props.t,
    loading = props.loading,
    ios = props.ios,
    initialDays = props.initialDays,
    onResetClick = props.onResetClick,
    darkMode = props.darkMode;
  var theme = (0, _styles.useTheme)();
  var datePickerDivRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDays = _useState2[0],
    setSelectedDays = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    range = _useState4[0],
    setRange = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    disabled = _useState6[0],
    setDisabled = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    days = _useState8[0],
    setDays = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    eDayList = _useState10[0],
    setEDayList = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    disabledDays = _useState12[0],
    setDisabledDays = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    initialMonth = _useState14[0],
    setInitialMonth = _useState14[1];
  var _useState15 = (0, _react.useState)(3),
    _useState16 = _slicedToArray(_useState15, 2),
    visibleMonth = _useState16[0],
    setVisibleMonth = _useState16[1];
  (0, _react.useEffect)(function () {
    var dd = _toConsumableArray(enabledDays !== null && enabledDays !== void 0 ? enabledDays : []);
    var latestDay = _lodash.default.chain(dd).sort().last().value();
    setInitialMonth(latestDay ? (0, _moment.default)(latestDay, "YYYYMMDD") : (0, _moment.default)());
  }, [enabledDays]);
  var clearDates = (0, _react.useCallback)(function () {
    if (initialDays) {
      setSelectedDays(_lodash.default.filter(initialDays, function (d) {
        var day = (0, _moment.default)(d).format("YYYYMMDD");
        return _lodash.default.includes(enabledDays, day);
      }));
      setRange({
        from: _lodash.default.first(initialDays),
        to: _lodash.default.last(initialDays)
      });
    }
  }, [enabledDays, initialDays]);
  (0, _react.useEffect)(function () {
    // console.log("GPSTrackingDatePanel", "initialDays", initialDays);

    clearDates();
  }, [clearDates]);
  (0, _react.useEffect)(function () {
    if (mobile && datePickerDivRef.current) {
      var scrollPos = 0;
      var element = datePickerDivRef.current;
      var noScroll = false;
      var needToLoad = false;
      var handleScroll = function handleScroll(e) {
        if (noScroll) {
          noScroll = false;
          return;
        }
        if (ios) {
          if (element.scrollTop > scrollPos) {
            //down
            if (element.scrollTop <= 0 && needToLoad) {
              needToLoad = false;
              setVisibleMonth(function (v) {
                return v + 1;
              });
            }
          } else {
            if (element.scrollTop < 0) {
              needToLoad = true;
              noScroll = true;
            }
          }
        } else {
          if (element.scrollTop > scrollPos) {
            //down
          } else {
            if (Math.max(element.scrollTop, 0) === 0) {
              setVisibleMonth(function (v) {
                return v + 3;
              });
              element.scrollTo(0, element.scrollTop + (222 + 32) * 3);
              noScroll = true;
            }
          }
        }
        // saves the new position for iteration.
        scrollPos = element.scrollTop;
      };
      element.addEventListener("scroll", handleScroll);
      setTimeout(function () {
        element.scrollTo(0, element.scrollHeight);
      }, 100);
      return function () {
        element.removeEventListener("scroll", handleScroll);
      };
    }
  }, [ios, mobile]);
  (0, _react.useEffect)(function () {
    if (variant === "multi") {
      setDays(selectedDays.length);
    } else if (variant === "range") {
      if (range) {
        if (!range.to || !range.from) {
          setDays(0);
        } else {
          var _range$to, _range$from;
          setDays(Math.floor((((_range$to = range.to) === null || _range$to === void 0 ? void 0 : _range$to.getTime()) - ((_range$from = range.from) === null || _range$from === void 0 ? void 0 : _range$from.getTime())) / (1000 * 3600 * 24) + 1));
        }
      }
    }
  }, [variant, range, selectedDays]);
  (0, _react.useEffect)(function () {
    setEDayList(_lodash.default.chain(enabledDays).map(function (d) {
      return (0, _moment.default)(d, "YYYYMMDD");
    }).sort(function (a, b) {
      return a.diff(b);
    }).value());
  }, [enabledDays]);
  (0, _react.useEffect)(function () {
    if (!enabledDays || enabledDays.length === 0) {
      setDisabledDays([(0, _moment.default)().toDate(), {
        after: (0, _moment.default)().toDate(),
        before: (0, _moment.default)().toDate()
      }]);
    } else {
      var eDays = _lodash.default.chain(enabledDays).map(function (d) {
        return (0, _moment.default)(d, "YYYYMMDD");
      }).sort(function (a, b) {
        return a.diff(b);
      }).value();
      var startD = _lodash.default.first(eDays);
      var endD = _lodash.default.last(eDays);
      var modifiers = [];
      if (startD && endD) {
        modifiers.push({
          before: startD.toDate(),
          after: endD.toDate()
        });
        modifiers.push.apply(modifiers, _toConsumableArray(_lodash.default.chain(_lodash.default.range(0, endD.diff(startD, "d"))).map(function (d) {
          var day = (0, _moment.default)(startD).add(d, "d");
          if (!_lodash.default.find(eDays, function (dd) {
            return dd.isSame(day);
          })) {
            return day.toDate();
          }
          return undefined;
        }).compact().value()));
      }
      setDisabledDays(modifiers);
    }
  }, [enabledDays]);
  var checkDisabledDay = (0, _react.useCallback)(function (day) {
    var d = (0, _moment.default)(day);
    return _lodash.default.filter(eDayList, function (ed) {
      return ed.isSame(d, "d");
    }).length === 0;
  }, [eDayList]);
  (0, _react.useEffect)(function () {
    setDisabled(days > total);
  }, [total, days]);

  // const handleResetClick = useCallback(() => {
  //   clearDates();
  // }, [clearDates]);

  var handelSelectedDays = function handelSelectedDays(day, modifiers, e) {
    var selected = modifiers.selected,
      disabled = modifiers.disabled;
    if (disabled) return;
    if (variant === "multi") {
      if (selected) {
        setSelectedDays(selectedDays.filter(function (selectedDay) {
          return !_reactDayPicker.DateUtils.isSameDay(selectedDay, day);
        }));
      } else {
        setSelectedDays(selectedDays.concat(day));
      }
    } else if (variant === "range") {
      var newRange = range && range.from === range.to ? _reactDayPicker.DateUtils.addDayToRange(day, range) : {
        from: day,
        to: day
      };
      if (!newRange.to) {
        newRange.to = newRange.from;
      }
      setRange(newRange);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    dir: theme.direction
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dateTypeDiv
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dateTypeTextDiv
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "BodyBold",
    className: (0, _clsx7.default)(classes.dateTypeText, _defineProperty({}, classes.dateTypeTextActive, variant === "range")),
    onClick: function onClick() {
      return onChangeVariant("range");
    }
  }, t ? t("Range") : "Range")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dateTypeTextDiv
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "BodyBold",
    className: (0, _clsx7.default)(classes.dateTypeText, _defineProperty({}, classes.dateTypeTextActive, variant === "multi")),
    onClick: function onClick() {
      return onChangeVariant("multi");
    }
  }, t ? t("Multiple") : "Multiple")), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(classes.dateActiveDiv, _defineProperty({}, classes.activeMulti, variant === "multi"))
  })), mobile && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekdays", classes.weekTextDiv),
    role: "rowgroup"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-WeekdaysRow", classes.weekTextRowDiv),
    role: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Sunday"
  }, (_t = t === null || t === void 0 ? void 0 : t("Sun")) !== null && _t !== void 0 ? _t : "Sun"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Monday"
  }, (_t2 = t === null || t === void 0 ? void 0 : t("Mon")) !== null && _t2 !== void 0 ? _t2 : "Mon"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Tuesday"
  }, (_t3 = t === null || t === void 0 ? void 0 : t("Tue")) !== null && _t3 !== void 0 ? _t3 : "Tue"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Wednesday"
  }, (_t4 = t === null || t === void 0 ? void 0 : t("Wed")) !== null && _t4 !== void 0 ? _t4 : "Wed"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Thursday"
  }, (_t5 = t === null || t === void 0 ? void 0 : t("Thu")) !== null && _t5 !== void 0 ? _t5 : "Thu"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Friday"
  }, (_t6 = t === null || t === void 0 ? void 0 : t("Fri")) !== null && _t6 !== void 0 ? _t6 : "Fri"), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)("DayPicker-Weekday", classes.weekText),
    title: "Saturday"
  }, (_t7 = t === null || t === void 0 ? void 0 : t("Sat")) !== null && _t7 !== void 0 ? _t7 : "Sat"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.datePickerDiv,
    ref: datePickerDivRef
  }, loading && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loadginDiv
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default
  // className={classes.circularLoading}
  , {
    size: 48,
    thickness: 5,
    color: "primary"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative",
      paddingTop: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, {
    className: variant === "range" ? "Selectable" : "",
    month: (0, _moment.default)(initialMonth).subtract(mobile ? visibleMonth - 1 : 1, "month").toDate(),
    toMonth: (0, _moment.default)(initialMonth).toDate()
    // fromMonth={fromMonth.toDate()}
    ,
    numberOfMonths: mobile ? visibleMonth : 2,
    modifiers: {
      start: range && range.from,
      end: range && range.to,
      gray: checkDisabledDay
    },
    modifiersStyles: _DatePicker.modifierStyle,
    selectedDays: variant === "range" ? range : selectedDays,
    navbarElement: _DatePicker.Navbar,
    onDayClick: handelSelectedDays,
    weekdayElement: (0, _DatePicker.Weekday)(t),
    captionElement: (0, _DatePicker.CaptionLabel)(t),
    disabledDays: disabledDays
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(classes.btnDiv, _defineProperty({}, classes.btnDivMobile, mobile))
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(classes.count, _defineProperty({}, classes.countError, disabled))
  }, "".concat(days, "/").concat(total))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    children: (_t8 = t === null || t === void 0 ? void 0 : t("Clear")) !== null && _t8 !== void 0 ? _t8 : "Clear",
    variant: "outlined",
    color: darkMode ? "gray-dark" : "primary",
    className: (0, _clsx7.default)(classes.btnMargin, _defineProperty({}, classes.noHover, days > 0 && mobile)),
    disabled: days === 0,
    onClick: onResetClick
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    children: (_t9 = t === null || t === void 0 ? void 0 : t("OK")) !== null && _t9 !== void 0 ? _t9 : "OK",
    color: "primary",
    disabled: disabled || days === 0,
    onClick: function onClick() {
      return onClickOK(variant === "range" ? {
        range: range
      } : {
        dates: selectedDays
      });
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactHelmet.default, null, /*#__PURE__*/_react.default.createElement("style", null, "\n        ".concat(mobile ? "\n\n          .DayPicker-wrapper {\n            \n          }\n\n          .DayPicker-NavBar {\n            display: none;\n          }\n          \n          .DayPicker-Caption {\n            position: absolute;\n            top: -17px;\n            font-size:14px!important;\n            line-height:21px;\n            height:auto!important;\n            margin-bottom: 0;\n          }\n\n          .DayPicker-Months {\n            flex-wrap:nowrap;\n            display:flex;\n            flex-direction:column;\n          }\n\n          .DayPicker-Month {\n              width: 288px;\n              border-collapse: separate;\n              border-spacing: 0 6px;\n              margin: 32px 0 0 0;\n              min-height: 201px;\n              position: relative;\n          }\n\n          .DayPicker-Month:first-child {\n            margin-top: 0px;\n          }\n\n          .DayPicker-Month:last-child { margin-top: 32px; }\n\n          .DayPicker-Week {\n            margin: 3px 0;\n          }\n\n          .DayPicker-Month:first-child .DayPicker-Weekdays {\n            position:absolute;\n            top: -61px;\n            border-bottom: 1px solid ".concat(darkMode ? _pittaModules.DarkColors.primary["6"] : _pittaModules.LightColors.primary["6"], ";\n            width: 100%;\n            margin: 0;\n          }\n\n          .DayPicker-Month:first-child .DayPicker-Weekdays .DayPicker-WeekdaysRow {\n            display:flex;\n            justify-content: space-between;\n            padding-bottom: 6px;\n          }\n\n          .DayPicker-Month .DayPicker-Weekdays {\n            display: none;\n          }\n        ") : "\n          .DayPicker-Month:first-child {\n            margin-left: 16px;\n            margin-right: 12px;\n          }\n\n          .DayPicker-Month:last-child {\n            margin-left: 12px;\n            margin-right: 16px;\n          }\n          \n          .DayPicker-Caption {\n            position: absolute;\n            top: -38px;\n            left: 50%;\n            transform: translateX(-50%);\n            text-align: center;\n          }\n\n          .DayPicker-Months {\n            flex-wrap:nowrap;\n          }\n\n          .DayPicker-Month {\n            width: 252px;\n            margin-top: 56px;\n            min-height: 201px;\n            position: relative;\n          }\n        ", "\n          :focus {\n              outline: none;\n          }\n          .DayPicker-wrapper {\n            padding: 0;\n          }\n          .DayPicker {\n            background-color: ").concat(darkMode ? _pittaModules.DarkColors.primary["0"] : _pittaModules.LightColors.primary["0"], ";\n            box-sizing: border-box;\n            border-radius: 4px;\n            color: ").concat(darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"], "; \n          }\n          .DayPicker-Day--today {\n              font-weight: 400;\n          }\n          \n          .DayPicker-Day {\n            color: ").concat(darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"], "; \n            width: 36px;\n            height: 36px;\n            padding: 0;\n          }\n          .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {\n              background-color: ").concat(darkMode ? _pittaModules.DarkColors.primary["0"] : _pittaModules.LightColors.primary["0"], ";\n          }\n          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside),\n          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {\n            background-color: ").concat(darkMode ? _pittaModules.DarkColors.primary["7"] : _pittaModules.LightColors.primary["7"], ";\n            color: ").concat(darkMode ? _pittaModules.DarkColors.primary["0"] : _pittaModules.LightColors.primary["0"], ";\n          }\n\n          .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {\n            background-color: ").concat(darkMode ? _pittaModules.DarkColors.primary["6"] : _pittaModules.LightColors.primary["6"], " !important;\n            color: ").concat(darkMode ? _pittaModules.DarkColors.primary["1"] : _pittaModules.LightColors.primary["1"], "; \n            border-radius: 0 !important;\n          }\n          .DayPicker-Day--gray {\n            opacity: 0.35;\n          }\n          "))));
};
exports.DatePicker = DatePicker;